import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectCaseUpdates } from '@debbie/cortex/dist/case/selectors.js';
import { selectUpdateTypes, selectUpdateTypesMap, } from '@debbie/cortex/dist/update-types/selectors.js';
import { Badge } from '..//index.js';
import THEME from '../../theme.js';
const ImportantUpdates = (props) => {
    const lang = useSelector((s) => s.lang);
    const updates = useSelector((s) => selectCaseUpdates(s, props.caseId));
    const updateTypes = useSelector(selectUpdateTypes);
    const updateTypesMap = useSelector(selectUpdateTypesMap);
    const importantUs = useSelector((s) => {
        if (!updateTypes) {
            return null;
        }
        return (updates &&
            updates.filter((u) => {
                const uT = updateTypesMap[u.updateTypeId];
                return uT && uT.important;
            }));
    });
    const importantUpdates = importantUs &&
        importantUs.filter((item, pos) => importantUs.findIndex((u) => u.updateTypeId === item.updateTypeId) ==
            pos);
    return (React.createElement("div", { style: {
            marginBottom: '1em',
        } }, importantUpdates &&
        importantUpdates.map((u) => {
            const uT = updateTypesMap[u.updateTypeId];
            if (!uT)
                return null;
            return (React.createElement("p", { "data-tooltip-id": "tooltip-default", "data-tooltip-content": moment(u.createdAt).format(THEME.DATE_FORMAT_LONG), key: u.updateId, style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    marginBottom: '0px',
                    marginTop: '0.3em',
                } },
                React.createElement(Badge, { theme: 
                    // @ts-ignore
                    THEME[uT.importantTheme] }, lang.updateTypes[u.updateTypeId] || u.label)));
        })));
};
export default ImportantUpdates;
//# sourceMappingURL=ImportantUpdates.js.map